
import MockLoadingBlock from './MockLoadingBlock'
import classes from './MockPatientDetails.module.css'

const MockPatientDetails = () => {
    return <div className={classes.container}>
        <div className={classes.main}>
            <MockLoadingBlock height={68} noMargin={true}/>
            <div className={classes.group}>
                <div className={classes.box_3}>
                    <MockLoadingBlock height={150} noMargin={true}/>
                </div>
                <div className={classes.box_1}>
                    <MockLoadingBlock height={150} noMargin={true}/>
                </div>
            </div>
            <MockLoadingBlock height={780} noMargin={true}/>
        </div>

        <div className={classes.sidebar}>
            <div className={classes.row}><MockLoadingBlock height={255} noMargin={true}/></div>
            <div className={classes.row}><MockLoadingBlock height={282}/></div>
            <div className={classes.row}><MockLoadingBlock height={154}/></div>
        </div>
    </div>
}

export default MockPatientDetails